import React from 'react';

interface State { hasError: boolean; }

export class ServiceProfileErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // Future: integrate with structured logger / monitoring
    // Safe message extraction to avoid assuming Error shape
    const message = error instanceof Error ? error.message : String(error);
    // eslint-disable-next-line no-console
    console.error('ServiceProfile render error:', message, { error, info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 border rounded-md bg-red-50 text-sm text-red-700">
          Something went wrong loading this service profile.
        </div>
      );
    }
    return this.props.children;
  }
}
